import { render } from "./error404.vue?vue&type=template&id=a2180290"
import script from "./error404.vue?vue&type=script&lang=js"
export * from "./error404.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__